<template>
  <div class="status-wrapper">
    <div class="status-bar">
      <timeline-step
        v-for="step in timeline"
        :key="step.id"
        :status="step.status"
        :step="step.step"
        :title="step.title"
        :maximumStep="stepCount"
        :configuration="step"
        @titleClicked="currentstep = $event"
        @todoListClicked="emit('todoListClicked')"
      >
        <template
          v-slot:title
          v-if="
            productTypeId === ProductIds.REFI &&
            step.id === TimelineMilestoneIds.RIGHT_TO_CANCEL_PERIOD
          "
          >Right To Cancel Period<tooltip-component>
            <template #toggle><icon icon="info" /></template>
            <div>
              You have a right to cancel this transaction, without penalty, by the Right To Cancel
              Date shown on your Final Disclosure. No funds will be disbursed until after this time.
              You may cancel by clicking the “Cancel Application” link above.
            </div>
          </tooltip-component></template
        >
        <template v-slot:caption v-if="useV2 && currentstep === step.step">
          <timeline-step-description
            class="mobile"
            :step="step.step"
            :status="selectedStep.status"
          />
        </template>
      </timeline-step>
    </div>

    <template v-if="useV2">
      <div class="divider"></div>
      <timeline-step-description :step="selectedStep.step" :status="selectedStep.status"
    /></template>
  </div>
</template>
<script setup lang="ts">
import { defineEmits, onUnmounted } from "vue";
import { useStore } from "vuex";
import Icon from "@/components/shared/Icon.vue";
import TimelineStep from "@/components/timeline/TimelineStep.vue";
import TimelineStepDescription from "@/components/timeline/TimelineStepDescription.vue";
import TooltipComponent from "@/components/shared/TooltipComponent.vue";
import { ProductIds } from "@/config/constants";
import useApplicationStatus from "@/composables/application-status/useApplicationStatus";
import { TimelineMilestoneIds } from "@/models/applicationStatus";
const store = useStore();

const emit = defineEmits<{
  (e: "todoListClicked"): void;
  (e: "cancelApplication"): void;
  (e: "closeCancellationForm"): void;
}>();

const { timeline, useV2, currentstep, selectedStep, stepCount, productTypeId } =
  useApplicationStatus();

onUnmounted(() => {
  store.dispatch("applicationStatusModule/resetState");
});
</script>
